import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  useTheme,
  Card,
  CardContent,
  Chip,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const planos = [
  {
    title: "Plano Individual",
    priceRange: "A partir de R$ 199,90/mês",
    features: [
      "Consultas e exames",
      "Internação hospitalar",
      "Urgência e emergência 24h",
      "Telemedicina",
    ],
    highlight: false,
  },
  {
    title: "Plano Familiar",
    priceRange: "A partir de R$ 399,90/mês",
    features: [
      "Consultas e exames",
      "Internação hospitalar",
      "Urgência e emergência 24h",
      "Telemedicina",
      "Desconto progressivo por dependente",
    ],
    highlight: true,
  },
  {
    title: "Plano Empresarial",
    priceRange: "A partir de R$ 149,90/mês por pessoa",
    features: [
      "Consultas e exames",
      "Internação hospitalar",
      "Urgência e emergência 24h",
      "Telemedicina",
      "Medicina ocupacional",
    ],
    highlight: false,
  },
];

export const CtaSection = () => {
  const theme = useTheme();

  return (
    <Box
      id="planos"
      sx={{
        py: { xs: 6, md: 10 },
        backgroundColor: "#F0F7FF", // Fundo azul claro
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            variant="h6"
            component="p"
            color="primary"
            sx={{ fontWeight: 600, mb: 2 }}
          >
            CONHEÇA NOSSOS PLANOS
          </Typography>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontWeight: 700,
              mb: 2,
              color: theme.palette.text.primary,
            }}
          >
            Soluções para você, sua família ou empresa
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.secondary,
              maxWidth: "800px",
              mx: "auto",
              mb: 5,
            }}
          >
            Trabalhamos com as principais operadoras de saúde para oferecer o
            plano perfeito para suas necessidades e orçamento.
          </Typography>

          <Grid container spacing={4} justifyContent="center">
            {planos.map((plano, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "16px",
                    boxShadow: plano.highlight
                      ? `0 8px 24px rgba(${theme.palette.primary.main.replace(
                          /^#([A-Fa-f0-9]{2})([A-Fa-f0-9]{2})([A-Fa-f0-9]{2})$/,
                          "0x$1, 0x$2, 0x$3"
                        )}, 0.15)`
                      : "0 4px 12px rgba(0, 0, 0, 0.05)",
                    border: plano.highlight
                      ? `2px solid ${theme.palette.primary.main}`
                      : "none",
                    transform: plano.highlight ? "scale(1.05)" : "none",
                    position: "relative",
                    overflow: "visible",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: plano.highlight
                        ? "scale(1.08)"
                        : "scale(1.03)",
                    },
                  }}
                >
                  {plano.highlight && (
                    <Chip
                      label="Mais Popular"
                      color="primary"
                      sx={{
                        position: "absolute",
                        top: "-12px",
                        right: "50%",
                        transform: "translateX(50%)",
                        fontWeight: "bold",
                      }}
                    />
                  )}

                  <CardContent sx={{ p: 4, flexGrow: 1 }}>
                    <Typography
                      variant="h4"
                      component="h3"
                      sx={{
                        fontWeight: 700,
                        mb: 1,
                        color: plano.highlight
                          ? theme.palette.primary.main
                          : theme.palette.text.primary,
                      }}
                    >
                      {plano.title}
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        mb: 3,
                        color: theme.palette.text.secondary,
                        fontWeight: 500,
                      }}
                    >
                      {plano.priceRange}
                    </Typography>

                    <Box sx={{ mb: 4 }}>
                      {plano.features.map((feature, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mb: 1.5,
                          }}
                        >
                          <CheckCircleOutlineIcon
                            sx={{
                              mr: 1.5,
                              color: plano.highlight
                                ? theme.palette.primary.main
                                : theme.palette.secondary.main,
                            }}
                          />
                          <Typography variant="body1">{feature}</Typography>
                        </Box>
                      ))}
                    </Box>

                    <Button
                      variant={plano.highlight ? "contained" : "outlined"}
                      color={plano.highlight ? "primary" : "primary"}
                      fullWidth
                      size="large"
                      href="#formulario"
                      startIcon={plano.highlight ? <WhatsAppIcon /> : null}
                      sx={{
                        py: 1.5,
                        fontWeight: "bold",
                        borderRadius: "8px",
                      }}
                    >
                      {plano.highlight
                        ? "Quero este plano"
                        : "Solicitar cotação"}
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Box sx={{ mt: 6, textAlign: "center" }}>
            <Typography
              variant="body2"
              sx={{ color: theme.palette.text.secondary, mb: 2 }}
            >
              Não encontrou o plano ideal? Temos mais opções para você!
            </Typography>
            <Button
              variant="text"
              color="primary"
              href="#formulario"
              sx={{ fontWeight: "bold" }}
            >
              Fale com nossos consultores
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
